/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-03-25 14:29:15
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-09-27 15:36:56
 * @FilePath: \lightning\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import home from "../views/home"
import warning from "../views/warning"
import inspection from "../views/inspection"
import set from "../views/set"
import test from "../views/test"
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'test',
  //   component:test
  // },
  // {
  //   path: '/test',
  //   name: 'test',
  //   component: test
  // },
  {
    path: '/',
    name: 'home',
    component: home

  },
  {
    path: '/warning',
    name: 'warning',
    component: warning

  },
  {
    path: '/inspection',
    name: 'inspection',
    component: inspection

  },
  {
    path: '/set',
    name: 'set',
    component: set

  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
